class InfoSlider extends HTMLElement {
  constructor() {
    super();

    this.preloadBackgroundImages().then(() => {
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", e => {
          this.mountSlider();
        });
      }

      this.mountSlider();

      window.addEventListener("shopify:block:select", e => {
        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });
    });
  }

  async preloadBackgroundImages() {
    const slides = this.querySelectorAll(".swiper-slide");
    const heroContent = document.querySelector(
      ".info-tabs .hero-banner__content"
    );

    if (slides.length > 0) {
      const firstSlide = slides[0];
      const firstImage = firstSlide.dataset.backgroundImage;
      if (firstImage) {
        const cleanedImage = firstImage.replace(
          /\/t\/\d+\/assets/,
          ""
        );
        heroContent.style.backgroundImage = `url(${cleanedImage})`;
      }
    }

    const imagePromises = Array.from(slides).map(slide => {
      return new Promise(resolve => {
        const backgroundImage = slide.dataset.backgroundImage;
        if (backgroundImage) {
          const cleanedImage = backgroundImage.replace(
            /\/t\/\d+\/assets/,
            ""
          );
          const img = new Image();
          img.onload = () => resolve();
          img.src = cleanedImage;
        } else {
          resolve();
        }
      });
    });

    await Promise.all(imagePromises);
  }

  mountSlider() {
    const autoplayOptions = {
      delay: this.dataset.autoplayInterval
    };

    this.slider = new Swiper(this, {
      effect: "fade",
      rewind: true,
      slidesPerView: 1,
      speed: 600,
      followFinger: false,
      allowTouchMove: false,
      navigation: {
        nextEl: ".swiper-button--next-info",
        prevEl: ".swiper-button--prev-info"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (i, className) {
          return `
              <button class="${className}">
                <span>0${i + 1}</span>
                <svg class="square-progress" width="32" height="32">
                  <rect class="square-origin" width="32" height="32" rx="5" ry="5" />
                </svg>
                <svg class="progress" width="32" height="32" style="inset-inline-start: ${
                  0 - (i * 2.4 + 3.4)
                }rem">
                  <circle class="circle-origin" r="14" cx="16" cy="16"></circle>
                </svg>
              </button>
            `;
        }
      },
      autoplay:
        this.dataset.autoplay === "true" ? autoplayOptions : false,
      on: {
        init: this.handleSlideChange.bind(this),
        slideChange: this.handleSlideChange.bind(this)
      }
    });
    const swiperSlider = this.slider;
    const buttons = document.querySelectorAll(
      ".info-tabs .hero-banner__content-wrapper--buttons .button"
    );

    if (buttons) {
      const buttons = document.querySelectorAll(
        ".info-tabs .hero-banner__content-wrapper--buttons .button"
      );

      if (buttons.length > 0) {
        buttons[0].classList.remove("button--outlined");
        buttons[0].classList.add("button--filled");
      }

      buttons.forEach((button, index) => {
        button.addEventListener(
          "click",
          function () {
            swiperSlider.slideTo(index, 600);
            this.updateDescriptionAndButtons(index);
          }.bind(this)
        );
      });
    }
  }

  updateDescriptionAndButtons(slideIndex) {
    const buttons = document.querySelectorAll(
      ".info-tabs .hero-banner__content-wrapper--buttons .button"
    );
    const descriptions = document.querySelectorAll(
      ".info-tabs .hero-banner__content-wrapper--description .description-slide"
    );

    buttons.forEach((button, index) => {
      if (index === slideIndex) {
        const parentDiv = button.closest(".swiper-slide");
        if (parentDiv) {
          parentDiv.classList.add("swiper-slide-active");
        }
        button.classList.add("active");
        button.classList.remove("button--outlined");
        button.classList.add("button--filled");
      } else {
        const parentDiv = button.closest(".swiper-slide");
        if (parentDiv) {
          parentDiv.classList.remove("swiper-slide-active");
        }
        button.classList.remove("active");
        button.classList.add("button--outlined");
        button.classList.remove("button--filled");
      }
    });

    descriptions.forEach(description => {
      description.style.display = "none";
    });
    const activeDescription = document.querySelector(
      `.description-slide[data-slide-index="${slideIndex}"]`
    );
    if (activeDescription) {
      activeDescription.style.display = "block";
    }
  }

  handleSlideChange(swiper) {
    const heroContent = document.querySelector(
      ".info-tabs .hero-banner__content"
    );

    if (!heroContent) {
      return;
    }

    const activeSlide = swiper.slides[swiper.activeIndex];
    let backgroundImage = activeSlide.dataset.backgroundImage;

    if (backgroundImage) {
      const cleanedBackgroundImage = backgroundImage.replace(
        /\/t\/\d+\/assets/,
        ""
      );

      const img = new Image();
      img.src = cleanedBackgroundImage;
      img.onload = function () {
        heroContent.style.backgroundImage = `url(${cleanedBackgroundImage})`;
        heroContent.style.transition = "background-image 0.2s ease";
      };
    }
    this.updateDescriptionAndButtons(swiper.activeIndex);
  }
}

customElements.define("info-slider", InfoSlider);
